import React from "react";
import { TimeTabs } from "./TimeTabs"; // Adjust the path as needed

export default function DashboardPage() {
  return (
    <div className="min-h-screen bg-base-100 p-4 mx-auto max-w-3xl pt-0 pb-32">
      {/* Time Tabs Component */}
      <TimeTabs />
      <h1 className="text-2xl font-bold text-base-content mb-4 pl-4">
        Expanded Data Goes here
      </h1>
      {/* Add your content below */}
      <div className="mt-8">{/* Page content goes here */}</div>
    </div>
  );
}
